import { EnvironmentProviders, inject, provideEnvironmentInitializer } from '@angular/core';
import { environment } from '@scheduler-frontend/environments';
import { StorageService } from '@techniek-team/storage';
import { diff } from './functions/diff.function';

export function provideClearCacheOnMajorUpgrade(databaseName: string): EnvironmentProviders[] {
  return [
    provideEnvironmentInitializer(() => {
      const storageService = inject(StorageService);
      let currentRelease = environment.release;

      const checkRelease = async () => {
        const release = await storageService.get<string>('cacheVersion');

        if (currentRelease === 'v12.16.0') {
          currentRelease = 'v0.0.0';
        }

        if (release && diff(currentRelease, release) === 'major') {
          await storageService.clearAll();
          indexedDB.deleteDatabase('_ionickv');
          indexedDB.deleteDatabase(databaseName);
          localStorage.clear();
          sessionStorage.clear();
          await cookieStore
            .getAll()
            .then((cookies) =>
              Promise.all(
                cookies.map((cookie) => {
                  if (cookie.name) {
                    return cookieStore.delete(cookie.name);
                  }
                  return Promise.resolve();
                }),
              ),
            )
            .catch();
        }

        await storageService.set('cacheVersion', currentRelease);
      };

      void checkRelease();
    }),
  ];
}
